import { createEntityAdapter, EntityState } from '@ngrx/entity';

import { mongoIdAdapter, SortDirection } from '@ninety/mobile/platform/api';

import { HeadlinesStatusEnum } from './headlines-status-enums';
import { HeadlineModel } from './headlines.model';

const selectId = mongoIdAdapter<HeadlineModel & { _id: string }>();
export const headlinesEntityAdapter = createEntityAdapter<HeadlineModel>({ selectId });

export interface HeadlinesStateModel {
  isLoading: boolean;
  headlines: EntityState<HeadlineModel>;
  headlinesCount: number;
  pageIndex: number;
  pageSize: number;
  archived: boolean;
  isCascadedMessage: boolean;
  includeDiscussed: boolean;
  sortDirection: SortDirection;
  filterSet: boolean;
  statusFilter: HeadlinesStatusEnum;
  selectedHeadline: HeadlineModel;
  teamId: string | null;
  defaultTeamId: string | null;
}

export const headlinesStateDefaults = {
  headlinesCount: 0,
  pageIndex: 0,
  pageSize: 15,
  archived: false,
  isCascadedMessage: true,
  includeDiscussed: false,
  sortDirection: SortDirection.DESC,
  statusFilter: HeadlinesStatusEnum.unsolved,
  selectedHeadline: {} as HeadlineModel,
};

export const headlinesInitailState: HeadlinesStateModel = {
  ...headlinesStateDefaults,
  isLoading: true,
  headlines: headlinesEntityAdapter.getInitialState(),
  filterSet: false,
  teamId: null,
  defaultTeamId: null,
};
